import breakpoints from "themes/breakpoints"

// figma doc - https://www.figma.com/file/kfXA1bse9Xd24MjmTDOjJo/B2B?node-id=26%3A230&t=9ncgAoMyI0CSNdht-0

/**
 * - Heading large variant
 * - Font size 38px
 */
const headingLarge = {
    fontSize: "2.375rem", // 38px
    lineHeight: "3rem", // 48px
    fontWeight: 800,
    letterSpacing: "1px",
}

/**
 * - Heading medium large variant
 * - Font size 28px
 */
const headingMediumLarge = {
    fontSize: "1.75rem", // 28px
    lineHeight: "2.25rem", // 36px
    fontWeight: 800,
    letterSpacing: "1px",
}

/**
 * - Heading medium variant
 * - Font size 21px
 */
const headingMedium = {
    fontSize: "1.3125rem", // 21px
    lineHeight: "1.75rem", // 28px
    fontWeight: 800,
    letterSpacing: "0.5px",
}

/**
 * - Heading medium light variant
 * - Font size 21px
 */
const headingMediumLight = {
    fontSize: "1.3125rem", // 21px
    lineHeight: "1.75rem", // 28px
    fontWeight: 600,
    letterSpacing: "0.5px",
}

/**
 * - Heading medium caps variant
 * - Font size 16px
 */
const headingMediumCaps = {
    fontSize: "1rem", // 16px
    lineHeight: "1.5rem", // 24px
    fontWeight: 800,
    letterSpacing: "2px",
    textTransform: "uppercase" as const,
}

/**
 * - Heading small variant
 * - Font size 16px
 */
const headingSmall = {
    fontSize: "1rem", // 16px
    lineHeight: "1.5rem", // 24px
    fontWeight: 800,
    letterSpacing: "0.5px",
}

/**
 * - Heading small light variant
 * - Font size 16px
 */
const headingSmallLight = {
    fontSize: "1rem", // 16px
    lineHeight: "1.5rem", // 24px
    fontWeight: 600,
    letterSpacing: "0.5px",
}

/**
 * - Heading small caps variant
 * - Font size 14px
 */
const headingSmallCaps = {
    fontSize: "0.875rem", // 14px
    lineHeight: "1.25rem", // 20px
    fontWeight: 800,
    letterSpacing: "0.5px",
    textTransform: "uppercase" as const,
}

/**
 * - Heading small caps light variant
 * - Font size 14px
 */
const headingSmallCapsLight = {
    fontSize: "0.875rem", // 14px
    lineHeight: "1.25rem", // 20px
    fontWeight: 600,
    letterSpacing: "2px",
}

/**
 * - Heading extra small variant
 * - Font size 14px
 */
const headingXSmall = {
    fontSize: "0.875rem", // 14px
    lineHeight: "1.25rem", // 20px
    fontWeight: 800,
    letterSpacing: "0.5px",
}

/**
 * - Heading extra small caps variant
 * - Font size 12px
 */
const headingXSmallCaps = {
    fontSize: "0.75rem", // 12px
    lineHeight: "1rem", // 16px
    fontWeight: 800,
    letterSpacing: "2px",
    textTransform: "uppercase" as const,
}

/**
 * - Heading extra small caps variant
 * - Font size 12px
 */
const headingTinyCaps = {
    fontSize: "0.625rem", // 10px
    lineHeight: "1rem", // 16px
    fontWeight: 800,
    letterSpacing: "1.5px",
    textTransform: "uppercase" as const,
}

const bodySmallSemiBold = {
    fontSize: "0.875rem", //14px
    lineHeight: "1.25rem", // 20px
    fontWeight: 500,
}

/**
 * Body small variant
 * Font size 14px
 */
const bodySmall = {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem", // 20px
}

/**
 * Body xsmall variant
 * Font size 12px
 */
const bodyXSmall = {
    fontSize: "0.75rem", // 12px
    lineHeight: "0.875rem", // 14px
}

/**
 * Body small bold variant
 * Font size 14px
 */
const bodySmallBold = {
    fontSize: "0.875rem", //14px
    fontWeight: 700,
    lineHeight: "1.25rem", // 20px
}

/**
 * Section Heading variant - Heading Medium Large
 * Font size 21px on < 768px, 28px on > 768px screen sizes
 */
const secTitle = {
    fontWeight: 800,
    fontSize: "1.3125rem", // 21px
    lineHeight: "1.75rem", // 28px
    [breakpoints.up("sm")]: {
        fontSize: "1.75rem", // 28px
        lineHeight: "2.125rem", // 34px
    },
}

/**
 * Body default variant
 * Font size 16px
 */
const bodyDefault = {
    fontSize: "1rem", // 16px
    lineHeight: "1.5rem", // 24px
}

/**
 * Body bold variant
 * Font size 16px
 */
const bodyBold = {
    fontWeight: 800,
    fontSize: "1rem", // 16px
    lineHeight: "1.5rem", // 24px
}

/**
 * Small caps variant
 * Font size 12px on < 768px, 14px on > 768px screen sizes
 */
const smallCaps = {
    fontSize: "0.75rem", // 12px
    lineHeight: "0.875rem", // 14px
    letterSpacing: "2px",
    [breakpoints.up("sm")]: {
        fontSize: "0.875rem", // 14px
        lineHeight: "1rem", // 16px
    },
}

/**
 * XSmall caps variant
 * Font size 12px
 */
const xsmallCaps = {
    textTransform: "uppercase" as const,
    fontSize: "0.75rem", // 12px
    lineHeight: "0.875rem", // 14px
    letterSpacing: "2px",
    fontWeight: 800,
}

/**
 * links variant
 * Font size 14px
 */
const links = {
    fontSize: "0.875rem", // 14px
    lineHeight: "1.25rem", // 20px
    fontWeight: 700,
}

/**
 * Tiny caps variant
 * Font size 10px
 */
const tinyCaps = {
    textTransform: "uppercase" as const,
    fontSize: "0.625rem", // 10px
    lineHeight: "0.75rem", // 12px
    letterSpacing: "1.5px",
    fontWeight: 800,
}

const bodySemiBold = {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
}
/**
 * Micro caps variant
 * Font size 8px
 */
const microCaps = {
    textTransform: "uppercase" as const,
    fontSize: "0.5rem", // 8px
    lineHeight: "0.75rem", // 12px
    letterSpacing: "1.5px",
    fontWeight: 800,
}

/**
 * Button XS variant
 * Font size 8px
 */
const buttonXSmall = {
    fontSize: "0.75rem", // 12px
    lineHeight: "0.875rem", // 14px
    fontWeight: 700,
}

/**
 * Typography with heading & subHeading variants
 */
const typography = {
    fontFamily: "Public Sans, Helvetica, Arial, sans-serif",
    headingLarge,
    headingMediumLarge,
    headingMedium,
    headingMediumLight,
    headingMediumCaps,
    headingSmall,
    headingSmallLight,
    headingSmallCaps,
    headingSmallCapsLight,
    headingXSmall,
    headingXSmallCaps,
    headingTinyCaps,
    bodySmallSemiBold,
    bodySmall,
    bodyXSmall,
    bodySmallBold,
    secTitle,
    bodyDefault,
    bodyBold,
    smallCaps,
    xsmallCaps,
    tinyCaps,
    microCaps,
    links,
    buttonXSmall,
    bodySemiBold,
}

export default typography
